import type { interfaces } from 'inversify';
import { useContainer } from './useContainer';

export function useInstance<T>(serviceIdentifier: interfaces.ServiceIdentifier<T>): T {
  return useContainer().get(serviceIdentifier);
}
